import {getVPCServiceWithoutSlash} from "./App/utils";

const turtlesStory = `Turtles, often perceived as slow and steady creatures, offer a fascinating glimpse into a unique psychological framework that can be applied to various aspects of life, including personal development, creative pursuits, and even competitive sports. The psychology of turtles is rooted in consistency, patience, and a long-term perspective, which are qualities that can lead to significant success over time.`
const PIPE_API_BASE_URL = getVPCServiceWithoutSlash('pipe') || 'https://pipe.openkbs.com';


export const appInstallationProps = {
    'requireAtLeastOneOptional': 'requireAtLeastOneOptional',
}

export const appServiceTypes = {
    'main-chat-model': 'main-chat-model',
    'backend-chat-function': 'backend-chat-function',
    'frontend-chat-function': 'frontend-chat-function',
    'chat-input-tool': 'chat-input-tool',
    'image-editor-generation-model': 'image-editor-generation-model'
}

export const interfaces = {
    'doc-to-text': 'doc-to-text',
    'webpage-to-text': 'webpage-to-text',
    'image-to-text': 'image-to-text',
    'ocr': 'ocr',
    'inpaint': 'inpaint',
    'upscale': 'upscale',
    'text-to-image': 'text-to-image',
    'text-to-speech': 'text-to-speech',
    'speech-to-text': 'speech-to-text',
    'translation' : 'translation',
    'internet-search' : 'internet-search',
    'embedding' : 'embedding',
    'text-generation' : 'text-generation',
    'items-search-engine' : 'items-search-engine',
}

export const EmbeddingDimensions = [256, 512, 768, 1024, 1536, 3072];

export const EmbeddingModels = {
    "text-embedding-3-large": {
        url: "https://openai.openkbs.com",
        interfaces: [interfaces["embedding"]],
        serviceDescription: 'High-accuracy text embeddings for semantic search',
        category: 'Embedding',
        method: "POST",
        params: [
            { name: "action", value: "createEmbedding" },
            { name: "input", value: turtlesStory.repeat(4) },
            { name: "model", value: "text-embedding-3-large" },
        ],
        accountId: 'e08661d0b2fad0873b63be1f122c92a1',
        name: 'OpenAI Text Embedding v3 large',
        vendor: 'openai',
        inputPrice: 13, // 13
        context: 8191,
        defaultDimension: 1536,
        dimension: 3072,
        default: true,
    },
    "text-embedding-3-small": {
        url: "https://openai.openkbs.com",
        interfaces: [interfaces["embedding"]],
        serviceDescription: 'Text embeddings for semantic search, optimized for latency and storage.',
        category: 'Embedding',
        method: "POST",
        params: [
            { name: "action", value: "createEmbedding" },
            { name: "input", value: turtlesStory.repeat(14) },
            { name: "model", value: "text-embedding-3-small" },
        ],
        accountId: '1c4e67b5351f79272f7ebe20f0495557',
        name: 'OpenAI Text Embedding v3 small',
        vendor: 'openai',
        inputPrice: 2, // 2
        dimension: 1536,
        context: 8191
    }
}

const GPTCommonParams = [
    { name: "temperature", value: 0, type: 'int' },
    // { name: "max_tokens", value: null, type: 'int' },
]
export let ChatModels = {
    "gemini-3-flash": {
        accountId: '59b18eb9139fc90d84fca46eb67f2baf',
        interfaces: [interfaces["text-generation"]],
        category: 'Chat',
        frontendTokenLimit: 120000,
        vendor: 'google',
        name: 'Gemini 3.1 Flash',
        vision: {
            type: 'image_url'
        },
        size: 'Large',
        inputPrice: 50,
        outputPrice: 300,
        context: 900000
    },
    "gemini-3-pro": {
        accountId: 'ad231545256f69e735ff3c86aeb23bbd',
        interfaces: [interfaces["text-generation"]],
        category: 'Chat',
        frontendTokenLimit: 120000,
        vendor: 'google',
        name: 'Gemini 3 Pro',
        vision: {
            type: 'image_url'
        },
        size: 'Large',
        inputPrice: 250,
        outputPrice: 1500,
        context: 900000
    },
    "claude-sonnet-4-5-20250929": {
        accountId: '642e98f3d8c4bbe201368e8b4a64c2be',
        interfaces: [interfaces["text-generation"]],
        vision: {
            type: 'image_url'
        },
        category: 'Chat',
        frontendTokenLimit: 190000,
        maxThinkingTokens: 32000,
        vendor: 'anthropic',
        subvendor: 'anthropic',
        name: "Claude 4.5 Sonnet",
        size: 'Large',
        visionPricePerImage: 750,
        inputPrice: 400, // 300
        outputPrice: 2000, // 1500
        context: 200000
    },
    "gpt-5.1": {
        url: "https://openai.openkbs.com",
        interfaces: [interfaces["text-generation"]],
        serviceDescription: 'Affordable model balancing speed and intelligence',
        method: "POST",
        params: [
            { name: "action", value: "createChatCompletion" },
            { name: "messages", value: JSON.stringify([{role: 'user', content: "Generate a clever and original joke" }])},
            { name: "model", value: "gpt-5.1" },
            ...GPTCommonParams
        ],
        accountId: "33f533f7f985c24fe3700723fa1a775c",
        vision: {
            type: 'image_url'
        },
        category: 'Chat',
        default: false,
        frontendTokenLimit: 120000,
        searchLimit: 20000,
        vendor: 'openai',
        name: 'GPT 5.1',
        size: 'Large',
        visionPricePerImage: 750,
        inputPrice: 150,
        outputPrice: 1200,
        context: 400000
    },
    "gemini-2.5-pro-preview-03-25": {
        interfaces: [interfaces["text-generation"]],
        accountId: 'e6268ed33376a02a6824af3c34eb3f49',
        category: 'Chat',
        frontendTokenLimit: 120000,
        vendor: 'google',
        name: 'Gemini 2.5 Pro',
        vision: {
            type: 'image_url'
        },
        size: 'Large',
        inputPrice: 150,
        outputPrice: 1200,
        context: 200000
    },
    "gpt-4o": {
        url: "https://openai.openkbs.com",
        interfaces: [interfaces["text-generation"]],
        serviceDescription: 'Provides GPT-4-level intelligence but is much faster and improves on its capabilities across text, voice, and vision',
        method: "POST",
        params: [
            { name: "action", value: "createChatCompletion" },
            { name: "messages", value: JSON.stringify([{role: 'user', content: "Generate a clever and original joke" }])},
            { name: "model", value: "gpt-4o" },
            ...GPTCommonParams
        ],
        accountId: "5b4ba6503bf5d67921123c1e54489735",
        vision: {
            type: 'image_url'
        },
        category: 'Chat',
        default: true,
        frontendTokenLimit: 120000,
        searchLimit: 20000,
        vendor: 'openai',
        name: 'GPT 4 Omni',
        size: 'Large',
        visionPricePerImage: 750, // ~760 (max)
        inputPrice: 500, // ~500
        outputPrice: 1500, // ~1500
        context: 128000
    },

    "o3-mini": {
        url: "https://openai.openkbs.com",
        interfaces: [interfaces["text-generation"]],
        serviceDescription: 'o3-mini is a fast, cost-efficient reasoning model tailored to coding, math, and science use cases. ',
        method: "POST",
        params: [
            { name: "action", value: "createChatCompletion" },
            { name: "messages", value: JSON.stringify([{role: 'user', content: "Describe a day in the life of a citizen in a futuristic utopia where AI and humans coexist harmoniously." }])},
            { name: "model", value: "o3-mini" },
        ],
        accountId: "59986ba407c08c4a5eee9a582c6e5541",
        // vision: {
        //     type: 'image_url'
        // },
        category: 'Chat',
        default: false,
        frontendTokenLimit: 120000,
        searchLimit: 20000,
        vendor: 'openai',
        name: 'OpenAI o3-mini',
        size: 'Medium',
        inputPrice: 200, // 110
        outputPrice: 600, // 440
        context: 200000
    },

    // Anthropic
    "anthropic.claude-3-5-sonnet-20240620-v1:0": {
        accountId: '43bc37b5bed27551fc145a7244eb847b',
        interfaces: [interfaces["text-generation"]],
        vision: {
            type: 'image_url'
        },
        category: 'Chat',
        frontendTokenLimit: 190000,
        vendor: 'bedrock',
        subvendor: 'anthropic',
        name: "Claude 3.5 Sonnet",
        size: 'Large',
        visionPricePerImage: 750,
        inputPrice: 400, // 300
        outputPrice: 2000, // 1500
        context: 200000,
        obsolete: true,
    },

    "qwen-max": {
        interfaces: [interfaces["text-generation"]],
        accountId: '4720bb0546c4e124e566dbdc15d9928c',
        category: 'Chat',
        frontendTokenLimit: 120000,
        vendor: 'alibaba',
        name: 'Qwen-Max',
        size: 'Large',
        inputPrice: 300,
        outputPrice: 900,
        context: 120000
    },
    //
    // "gpt-5": {
    //     url: "https://openai.openkbs.com",
    //     interfaces: [interfaces["text-generation"]],
    //     serviceDescription: 'GPT-5 is our flagship model for coding, reasoning, and agentic tasks across',
    //     method: "POST",
    //     params: [
    //         { name: "action", value: "createChatCompletion" },
    //         { name: "messages", value: JSON.stringify([{role: 'user', content: "Generate a clever and original joke" }])},
    //         { name: "model", value: "gpt-5" },
    //         ...GPTCommonParams
    //     ],
    //     vision: {
    //         type: 'image_url'
    //     },
    //     visionPricePerImage: 750, // ~760 (max)
    //     accountId: "45ab91191e4fb7354a22ead72647564a",
    //     category: 'Chat',
    //     frontendTokenLimit: 350000,
    //     searchLimit: 40000,
    //     vendor: 'openai',
    //     name: 'GPT 5',
    //     size: 'Large',
    //     inputPrice: 150,
    //     outputPrice: 1200,
    //     context: 400000
    // },

    "meta.llama3.1-405b-cerebras": {
        interfaces: [interfaces["text-generation"]],
        accountId: '6bd7a41bee45012d1af04c46e5f382f8',
        category: 'Chat',
        frontendTokenLimit: 120000,
        vendor: 'cerebras',
        subvendor: 'meta',
        name: 'Llama 3.1 405B',
        size: 'Large',
        inputPrice: 600,
        outputPrice: 1200,
        context: 120000,
        instant: 'Cerebras',
        hidden: true
    },


    // OpenAI
    // "o1": {
    //     url: "https://openai.openkbs.com",
    //     interfaces: [interfaces["text-generation"]],
    //     serviceDescription: 'o1 reasoning model for complex tasks that require broad general knowledge.',
    //     method: "POST",
    //     params: [
    //         { name: "action", value: "createChatCompletion" },
    //         { name: "messages", value: JSON.stringify([{role: 'user', content: "Describe a day in the life of a citizen in a futuristic utopia where AI and humans coexist harmoniously." }])},
    //         { name: "model", value: "o1" },
    //     ],
    //
    //     accountId: "62d195797c67cad0e3ccd3368f2820e9",
    //     // vision: {
    //     //     type: 'image_url'
    //     // },
    //     category: 'Chat',
    //     default: true,
    //     frontendTokenLimit: 120000,
    //     searchLimit: 20000,
    //     vendor: 'openai',
    //     name: 'OpenAI o1',
    //     size: 'Large',
    //     visionPricePerImage: 750, // ~760 (max)
    //     inputPrice: 1500, // ~1500
    //     outputPrice: 6000, // ~6000
    //     context: 128000
    // },

    "gpt-5-mini": {
        url: "https://openai.openkbs.com",
        interfaces: [interfaces["text-generation"]],
        serviceDescription: 'GPT-5 Mini is our affordable model balancing speed and intelligence',
        method: "POST",
        params: [
            { name: "action", value: "createChatCompletion" },
            { name: "messages", value: JSON.stringify([{role: 'user', content: "Generate a clever and original joke" }])},
            { name: "model", value: "gpt-5-mini" },
            ...GPTCommonParams
        ],
        accountId: "63c0a5e19fbaf2f3b79eee01fad46922",
        vision: {
            type: 'image_url'
        },
        category: 'Chat',
        default: false,
        frontendTokenLimit: 350000,
        searchLimit: 40000,
        vendor: 'openai',
        name: 'GPT 5 Mini',
        size: 'Medium',
        visionPricePerImage: 500,
        inputPrice: 40,
        outputPrice: 250,
        context: 400000
    },

    "claude-haiku-4-5-20251001": {
        accountId: 'dfe4c7065819167376a8b0f2e4fe8a62',
        interfaces: [interfaces["text-generation"]],
        category: 'Chat',
        frontendTokenLimit: 190000,
        maxThinkingTokens: 32000,
        vendor: 'anthropic',
        subvendor: 'anthropic',
        name: "Claude 4.5 Haiku",
        size: 'Small',
        vision: {
            type: 'image_url'
        },
        visionPricePerImage: 750,
        inputPrice: 120,
        outputPrice: 600,
        context: 200000
    },

    "meta.llama3-1-70b-instruct-v1:0": {
        accountId: 'cc9dc9cfeb334fed436153f06d500ca7',
        interfaces: [interfaces["text-generation"]],
        category: 'Chat',
        frontendTokenLimit: 120000,
        vendor: 'bedrock',
        subvendor: 'meta',
        name: 'Llama 3.1 70B',
        size: 'Medium',
        inputPrice: 99, // 99
        outputPrice: 99, // 99
        context: 120000,
        obsolete: true
    },
    "qwen-3-235b-a22b-instruct-2507": {
        interfaces: [interfaces["text-generation"]],
        accountId: '05830bb6e8e65fda686c207912a5846f',
        category: 'Chat',
        frontendTokenLimit: 60000,
        vendor: 'cerebras',
        subvendor: 'meta',
        name: 'Qwen 3 235B Instruct',
        size: 'Large',
        inputPrice: 80,
        outputPrice: 150,
        context: 60000,
        instant: 'Cerebras 1400 T/s'
    },

    // // Meta
    // "meta-llama--Meta-Llama-3-8B-Instruct--default": {
    //     frontendTokenLimit: 7500,
    //     vendor: 'openkbs',
    //     name: 'Llama 3 8B',
    // },
    // "meta-llama--Meta-Llama-3-70B-Instruct--default": {
    //     frontendTokenLimit: 7500,
    //     vendor: 'openkbs',
    //     name: 'Llama 3 70B',
    // },

};

const randomNumber = (Math.floor(Math.random() * 10**15) + 1);

export const VisualModels = {
    "bfl.fluxPro11": {
        group: 'High Performance',
        category: 'Visual',
        accountId: '2c8d39d7225b6cad9f69dad3545a4975',
        interfaces: [interfaces["text-to-image"]],
        vendor: 'bfl',
        modelType: 'generation',
        name: 'FLUX1.1 pro',
        shortName: 'FLUX1.1 pro',
        serviceDescription: "Image generation model by Black Forest Labs",
        url: `${PIPE_API_BASE_URL}/cloud/flux-pro-1.1`,
        method: "GET",
        params: [
            { name: "prompt", value: "turtle holding a sign that says Build with OpenKBS" },
            { name: "seed", value: "203106373403242" },
        ],
        response: null,
        outputType: 'image',
        pricePerRequest: 4000
    },
    "stability.stableImageUltra": {
        group: 'High Performance',
        category: 'Visual',
        accountId: '9605bf7a3b6daaf7480f63d942237c05',
        interfaces: [interfaces["text-to-image"]],
        vendor: 'stability',
        modelType: 'generation',
        name: 'Stable Image Ultra',
        shortName: 'Stable Image Ultra',
        serviceDescription: "Image generation model by Stability AI",
        url: `${PIPE_API_BASE_URL}/cloud/stable-image--generate--ultra`,
        method: "GET",
        params: [
            { name: "prompt", value: "turtle holding a sign that says Build with OpenKBS" },
        ],
        response: null,
        outputType: 'image',
        pricePerRequest: 8000
    },
    "stability.sd35Large": {
        category: 'Visual',
        accountId: '262be27db3355db0b5164bc4f50fee5f',
        interfaces: [interfaces["text-to-image"]],
        vendor: 'openkbs',
        modelType: 'generation',
        group: 'Low Cost',
        name: 'Stable Diffusion 3.5 Large',
        shortName: 'SD3.5 Large',
        serviceDescription: "Image generation model by Stability AI",
        url: `${PIPE_API_BASE_URL}/stabilityai--stable-diffusion-3.5-large--default`,
        method: "POST",
        params: [
            { name: "prompt", value: "turtle holding a sign that says Build with OpenKBS" },
            { name: "negative_prompt", value: "" },
            { name: "num_inference_steps", value: "25" },
            { name: "seed", value: "203106373403242" },
        ],
        response: null,
        outputType: 'image',
        pricePerRequest: 2000
    },

    "stability.sd3Medium": {
        category: 'Visual',
        accountId: '9dd958f4d240fdf65b2d7adfec7b1c88',
        interfaces: [interfaces["text-to-image"]],
        vendor: 'openkbs',
        modelType: 'generation',
        group: 'Low Cost',
        name: 'Stable Diffusion 3 Medium',
        shortName: 'SD3 Medium',
        serviceDescription: "Image generation model by Stability AI",
        url: `${PIPE_API_BASE_URL}/stabilityai--stable-diffusion-3-medium-diffusers--default`,
        method: "POST",
        params: [
            { name: "prompt", value: "turtle holding a sign that says Build with OpenKBS" },
            { name: "negative_prompt", value: "" },
            { name: "num_inference_steps", value: "25" },
            { name: "seed", value: "203106373403242" },
        ],
        response: null,
        outputType: 'image',
        exclude: true,
        pricePerRequest: 1000
    },

    "stability.sdxl": {
        category: 'Visual',
        accountId: '823a4455353a7338a2ddb4d196407e02',
        interfaces: [interfaces["text-to-image"]],
        vendor: 'openkbs',
        modelType: 'generation',
        group: 'Low Cost',
        name: 'Stable Diffusion XL 1.0',
        shortName: 'SDXL 1.0',
        serviceDescription: "Image generation model by Stability AI",
        url: `${PIPE_API_BASE_URL}/stabilityai--stable-diffusion-xl-base-1.0--with-refiner`,
        method: "POST",
        params: [
            { name: "prompt", value: "photorealistic cat, masterpiece" },
            { name: "negative_prompt", value: "" },
            { name: "num_inference_steps", value: "25" },
            { name: "seed", value: randomNumber },
        ],
        response: null,
        outputType: 'image',
        exclude: true,
        pricePerRequest: 200, // 200-600
    },

    "animagine.xl3": {
        category: 'Visual',
        accountId: '9326273541dade3a8ea71c628db2ba35',
        interfaces: [interfaces["text-to-image"]],
        vendor: 'openkbs',
        modelType: 'generation',
        group: 'Low Cost',
        name: 'Animagine XL 3.0',
        shortName: 'Animagine XL 3.0',
        serviceDescription: "Generates high-quality anime images from textual prompts",
        url: `${PIPE_API_BASE_URL}/cagliostrolab--animagine-xl-3.0--default`,
        method: "POST",
        params: [
            { name: "prompt", value: "1girl, arima kana, oshi no ko, solo, upper body, v, smile, looking at viewer, outdoors, night" },
            { name: "negative_prompt", value: "nsfw, lowres, bad anatomy, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, watermark, username, blurry, artist name" },
            { name: "num_inference_steps", value: "25" },
            { name: "seed", value: randomNumber },
        ],
        response: null,
        outputType: 'image',
        exclude: true,
        pricePerRequest: 400,
    },

    "diffusers.sdxlInpaint": {
        category: 'Visual',
        accountId: '57b1931d746924c1628787850cf13ef1',
        interfaces: [interfaces["inpaint"]],
        vendor: 'openkbs',
        modelType: 'inpaint',
        name: 'Diffusers SDXL Inpaint',
        serviceDescription: "A latent text-to-image diffusion model",
        url: `${PIPE_API_BASE_URL}/diffusers--stable-diffusion-xl-1.0-inpainting-0.1--default`,
        method: "POST",
        params: [
            { name: "prompt", value: "Underwater dragon, 8k, high details" },
            { name: "negative_prompt", value: "" },
            { name: "num_inference_steps", value: "25" },
            { name: "image", value: 'https://files.openkbs.com/download/images/sdxl-text2img.png' },
            { name: "mask_image", value: 'https://files.openkbs.com/download/images/sdxl-inpaint-mask.png' },
            { name: "seed", value: randomNumber },

        ],
        response: null,
        outputType: 'image',
        exclude: true,
        pricePerRequest: 400,
    },

    "runwayml.sdxlInpaint": {
        category: 'Visual',
        accountId: '1fab01750660d8baabeecd6cd875a06f',
        interfaces: [interfaces["inpaint"]],
        vendor: 'openkbs',
        modelType: 'inpaint',
        name: 'Runwayml SDXL Inpaint',
        serviceDescription: "A latent text-to-image diffusion model",
        url: `${PIPE_API_BASE_URL}/runwayml--stable-diffusion-inpainting--default`,
        method: "POST",
        params: [
            { name: "prompt", value: "empty bench" },
            { name: "negative_prompt", value: "" },
            { name: "num_inference_steps", value: "25" },
            { name: "image", value: 'https://files.openkbs.com/download/images/sdxl-dog.png' },
            { name: "mask_image", value: 'https://files.openkbs.com/download/images/sdxl-dog-mask.png' },
            { name: "seed", value: randomNumber },
        ],
        response: null,
        outputType: 'image',
        exclude: true,
        pricePerRequest: 400,
    },

    "stability.sdxlInpaint": {
        category: 'Visual',
        accountId: 'fd9060e35f55ca1028f6a4fa9aa45fd7',
        interfaces: [interfaces["inpaint"]],
        vendor: 'openkbs',
        modelType: 'inpaint',
        name: 'Stable Diffusion XL Inpaint',
        serviceDescription: "A latent text-to-image diffusion model",
        url: `${PIPE_API_BASE_URL}/stabilityai--stable-diffusion-xl-base-1.0--inpaint-with-controlnet`,
        method: "POST",
        params: [
            { name: "prompt", value: "pink dog" },
            { name: "negative_prompt", value: "" },
            { name: "num_inference_steps", value: "25" },
            { name: "image", value: 'https://files.openkbs.com/download/images/sdxl-dog.png' },
            { name: "mask_image", value: 'https://files.openkbs.com/download/images/sdxl-dog-mask.png' },
            { name: "seed", value: randomNumber },
        ],
        response: null,
        outputType: 'image',
        exclude: true,
        pricePerRequest: 400,
    },

    "stability.upscalerX4": {
        category: 'Visual',
        accountId: '25ababf723807212473acb8c7277f5b7',
        interfaces: [interfaces["upscale"]],
        vendor: 'openkbs',
        modelType: 'upscale',
        outputType: 'image',
        name: 'Stable Diffusion Upscaler x4',
        method: "POST",
        params: [
            { name: "prompt", value: "a white cat" },
            { name: "negative_prompt", value: "" },
            { name: "num_inference_steps", value: "50" },
            { name: "image", value: 'https://files.openkbs.com/download/images/low-res-cat.png' },
            { name: "seed", value: randomNumber },
        ],
        serviceDescription: "Upscaler model",
        url: `${PIPE_API_BASE_URL}/stabilityai--stable-diffusion-x4-upscaler--default`,
        exclude: true,
        pricePerRequest: 800,
    },

    "crop": {
        accountId: '65d55b61ea145ec11ef62711fd1dc7de',
        name: 'crop',
        vendor: 'openkbs',
        modelType: 'crop',
        exclude: true,
        pricePerRequest: 1
    }
}

export const AudioModels = {
    "whisperLargeV3": {
        category: 'Audio',
        accountId: 'a3d08121d9bd3b0723e3bdd2046d0368',
        interfaces: [interfaces["speech-to-text"]],
        vendor: 'openkbs',
        pricePerMinute: 600, // openai price - $0.006 / minute (rounded to the nearest second)
        name: 'Whisper Large v3',
        shortName: 'Whisper',
        serviceDescription: "Extracts text from speech",
        url: `https://openai.openkbs.com/openai--whisper-large-v3--default`,
        method: "POST",
        params: [{ name: "audio", value: "https://files.openkbs.com/download/sample1.mp3" },],
        response: {
            "text":"As we all know, our planet is facing unprecedented challenges, from climate change to widespread pollution, deforestation, and loss of biodiversity. These issues are not just abstract problems; they affect us directly, impacting our health, our safety, and the future of our children"
        },
        modelType: "voiceToText"
    },
    "gcp.textToSpeech": {
        category: 'Audio',
        url: "https://api.openkbs.com/textToSpeech",
        accountId: '287434e0a2c405f9116ebc4e5b572cc3',
        interfaces: [interfaces["text-to-speech"]],
        name: 'Text To Speech',
        serviceDescription: 'Converts text into natural-sounding speech',
        method: "POST",
        params: [
            { name: "text", value: "Turtles can fly, everything can happen" },
            { name: "speakingRate", value: "1.2" },
            { name: "languageCode", value: "en-US" },
            { name: "ssmlGender", value: "NEUTRAL", options: ['MALE', 'FEMALE', 'NEUTRAL'] },
        ],
        pricePerCharacter: 3, // $0.000016 per byte (1 chat could be 2 bytes) https://cloud.google.com/text-to-speech/pricing
        response: null,
    },
}

export const WebTools = {
    "googleSearch": {
        category: 'Web',
        url: "https://webtools.openkbs.com/googleSearch",
        accountId: '3903571e4243f078b7e80d0d34039ead',
        interfaces: [interfaces["internet-search"]],
        name: 'Google Search',
        serviceDescription: 'Retrieves search results from Google',
        method: "POST",
        params: [
            { name: "q", value: "financial news" },
            { name: "num", value: 3 },
            { name: "dateRestrict", value: "d1" },
            { name: "linkSite", value: 'https://cnn.com' },
        ],
        response: null,
        pricePerRequest: 600 // google search $5.00 per 1000
    },

    "sendMail": {
        category: 'Web',
        url: "https://webtools.openkbs.com/sendMail",
        accountId: 'c4441e5e5b70960d0cbe9115580f8470',
        name: 'Send Mail',
        serviceDescription: 'Send Mail to user',
        pricePerRequest: 2700
    },

    "checkVAT": {
        category: 'Web',
        url: "https://webtools.openkbs.com/checkVAT",
        accountId: '4d1b78dcea635a271ae4831430a6d589',
        name: 'Check VAT',
        serviceDescription: 'Check VAT',
        pricePerRequest: 2700
    },

    "readWebpage": {
        category: 'Web',
        accountId: 'c10975c3ac1b34cbbf6fda8ca315c1d3',
        name: 'Read Webpage',
        interfaces: [interfaces["webpage-to-text"]],
        serviceDescription: 'Extracts text from web pages',
        url: "https://webtools.openkbs.com/readWebpage",
        method: "POST",
        params: [{ name: "url", value: "https://example.com" }, { name: "parsePrice", value: true },
            // { name: "withContent", value: false }
        ],
        response: null,
        pricePerMinute: 8 * 60
    },

    // Not Listed
    "readWebpages": {
        url: "https://webtools.openkbs.com/readWebpages",
        accountId: 'dd177891fefeaca103d101e0bee96e9d',
        name: 'Read Webpages',
        interfaces: [interfaces["webpage-to-text"]],
        pricePerMinute: 8 * 60
    },

    "gcp.textDetection": {
        category: 'Web',
        url: "https://api.openkbs.com/imageToText",
        accountId: 'b28ee77d5a8dce90abdff4781e8fdadf',
        interfaces: [interfaces["ocr"]],
        name: 'Text Detection',
        serviceDescription: 'Extracts text from images',
        method: "POST",
        params: [
            { name: "url", value: "https://files.openkbs.com/download/invoice.png" }
        ],
        pricePerRequest: 1000, // $1.50 Price per 1000 units https://cloud.google.com/vision/pricing
        response: null,
    },

    "documentToText": {
        category: 'Web',
        url: getVPCServiceWithoutSlash('doctools') || "https://doctools.openkbs.com",
        accountId: '0b9b011827d4a19b8d8e320f3a3f6337',
        interfaces: [interfaces["doc-to-text"]],
        name: 'Document To Text',
        serviceDescription: 'Extracts text from documents',
        method: "POST",
        params: [
            { name: "url", value: "https://files.openkbs.com/download/example.pdf" }
        ],
        pricePerMinute: 4 * 60,
        response: null,
    },

    // Not Listed
    "nodejs20": {
        url: "https://nodejs20.openkbs.com",
        accountId: 'f8b02db8f6fa04897c601474bed66a97',
        name: 'nodejs20',
        serviceDescription: 'NodeJS code execution service',
        pricePerInteraction: 600
    },

    // OpenKBS GPC
    "translateText": {
        category: 'Web',
        url: "https://api.openkbs.com/translateText",
        accountId: 'cbda4c0737d6a3c2e7c7201dc75ff0b2',
        interfaces: [interfaces["translation"]],
        name: 'Translate Text',
        serviceDescription: 'Provides text translation and detection',
        method: "POST",
        params: [
            { name: "text", value: "Hello" },
            { name: "to", value: "es" },
            { name: "method", value: 'translate', options: ['translate', 'detect'] },
        ],
        pricePerCharacter: 2, // $0.000020 per byte
        response: null,
    },
    "deep-research": {
        url: "https://openai.openkbs.com",
        accountId: "6d17fe264d06271c923198873fda5f94",
        category: 'Research',
        vendor: 'google',
        name: 'Deep Research',
        shortName: 'Deep Research',
        serviceDescription: 'Autonomous multi-step research agent. Plans, searches the web, reads sources, iterates, and synthesizes comprehensive reports with citations. Takes 5-60 minutes.',
        method: "POST",
        params: [
            { name: "action", value: "createDeepResearch" },
            { name: "model", value: "deep-research" },
            { name: "input", value: "Research the history of artificial intelligence" },
        ],
        inputPrice: 500,   // $2/1M base + markup
        outputPrice: 2000, // $12/1M base + markup
        context: 1000000,
        async: true, // Indicates this is an async operation that requires polling
    },
}

export let DatabaseServices = {
    "nosql": {
        url: "https://nosql.openkbs.com",
        serviceDescription: 'Fully managed NoSQL database providing low latency at any scale',
        accountId: "2d8e83d8a59f43c08f343eb0bc5cbe95",
        category: 'Database',
        default: true,
        vendor: 'openkbs',
        name: 'NoSQL service',
        storagePrice: 250, // for 1MB/month ($0.35 GB/month)
        readPrice: 150, // for 1000 Read Units ($0.5 per one million)
        writePrice: 150, // for 1000 Write Units ($1.5 per one million)

    },
    "indexedDB": {
        serviceDescription: 'In-browser database engine',
        category: 'Database',
        interfaces: [interfaces["items-search-engine"]],
        default: true,
        vendor: 'openkbs',
        name: 'IndexedDB',
        storagePrice: 0, // for 1MB/month ($0.35 GB/month)
        readPrice: 0, // for 1000 Read Units ($0.5 per one million)
        writePrice: 0, // for 1000 Write Units ($1.5 per one million)
    },
};

export let ElasticServices = {
    "elastic-functions": {
        accountId: '72d7218bf4c378c9fcd612572000b6a5',
        name: 'Elastic Functions',
        category: 'Elastic',
    },
    "elastic-postgres": {
        accountId: '9879575029f5109333487c36bb88b06a',
        name: 'Elastic Postgres',
        category: 'Elastic',
    },
    "elastic-storage": {
        accountId: 'a2437d435c0b4a1901317841e2a4f1a0',
        name: 'Elastic Storage',
        category: 'Elastic',
    },
    "nosql-database": {
        accountId: '8a790e6bdbb76488032cd1c917f578f2',
        name: 'NoSQL Memory',
        category: 'Elastic',
    },
};

export function getServicesByInterface(targetInterface) {
    const result = [];
    for (const serviceId in MyServices) {
        if (MyServices[serviceId]?.interfaces?.includes(targetInterface)) {
            const serviceWithId = { ...MyServices[serviceId], serviceId };
            result.push(serviceWithId);
        }
    }
    return result;
}

export const MyServices = {
    ...VisualModels,
    ...WebTools,
    ...AudioModels,
    ...DatabaseServices,
    ...ChatModels,
    ...EmbeddingModels,
    ...ElasticServices,
}
